import React, { Component } from 'react';
import { connect } from 'react-redux';
import './PaymentSuperFund.css';
import { getBankList, getBankProtocollnfoList } from '../action/myCardsAction.js';
import {protocolCode } from '../BankCode'
import Util from '../util';
import { Toast } from 'antd-mobile/lib';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import { getTempInfo} from '../common.js';
import { ActionSheet } from 'antd-mobile/lib';
import { myAddPhoneText } from '../action/publicAction';

let wrapProps;
class AddPhone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agreeIndex:0,
      btnFlag:false,
      text:'',
      paymentChannelId: '',
      bankList:'',
      bankListName:[],
      paymentChannelName: '',
      bankName: '',
      showSelectBankArrow:false,
      clicked:'',
      verificationCodeBool: false,
      agreementValue: ''
    };
  }
  componentWillMount(){
    document.title = "添加银行卡"
    this.props.dispatch(myAddPhoneText(this.props.location.state.mobileNo))
    this.toGetBankList();
  }
  succallback(){
    // alert()
  }
  errcallback(msg){
    // alert(msg)
  }
  componentWillUnmount(){
    ActionSheet.close()
  }
  showActionSheet = () => {
    let arr=this.state.bankListName;
    const BUTTONS = arr ;
    ActionSheet.showActionSheetWithOptions({
      options: BUTTONS,
      cancelButtonIndex: BUTTONS.length - 1,
      // title: '标题',
      message: '银行卡列表',
      maskClosable: true,
      'data-seed': 'logId',
      wrapProps,
    },
    (buttonIndex) => {
      if (buttonIndex==-1||buttonIndex==arr.length-1) {
        return;
      }
      this.setState({ bankName: BUTTONS[buttonIndex] });
      this.setState({
        paymentChannelId: this.state.bankList[buttonIndex].paymentChannelId,
        paymentChannelName: this.state.bankList[buttonIndex].paymentChannelName,
      });
    });
  }
  async toGetBankList(){
    let params = {
      token: await getTempInfo('shortToken'),
    };
    this.props.dispatch(getBankList(params, (content)=>this.getBankListSuccess(content), (msg)=>this.getBankListError(msg)));
  }

  getBankListSuccess(content){
    this.setState({loadingFlag: false});
    let bankListName=[];
    for (var i = 0; i < content.length; i++) {
      bankListName.push(content[i].paymentChannelName)
    }
    bankListName.push('取消')
    this.setState({
      bankList: content,
      bankListName:bankListName
    })
    this.toGetPaymentChannelId();
  }

  getBankListError(msg){
    this.setState({loadingFlag: false});
    Toast.info(msg, Util.ToastTime);
  }

  toGetPaymentChannelId(){
    let {bankList} = this.state;
    for(let i=0; i<bankList.length; i++){
      if(bankList[i].bankCode==this.props.location.state.bankCode){
        this.setState({
          paymentChannelId: bankList[i].paymentChannelId,
          paymentChannelName: bankList[i].paymentChannelName,
          bankName: bankList[i].paymentChannelName,
        });
      return;
      }
    }
    // Toast.show('未自动获取到所属银行，请手动选择', getToastConfPoint());
    // this.setState({downUpListShow: true});
    this.setState({showSelectBankArrow: true});
  }
  next(){
    this.setState({verificationCodeBool: true})
  }
   onChangeText(e){
    this.props.dispatch(myAddPhoneText(e.target.value))
  }
  isAgreeClick(){
    let { agreeIndex,text } =this.state;
    if (agreeIndex===0) {
      this.setState({
        agreeIndex:1
      })
    } else {
      this.setState({
        agreeIndex:0,
      })
    }
    
  }
  ProtocolPaper(name,value){
    let code=protocolCode[name];
    if(code){
      hashHistory.push({
        pathname:'/WebView',
        state:{name:name,code:code},
        query: {code:code}
      })
    }else{
      let newName = name.substring(1,name.length-1)
      hashHistory.push({
        pathname:'/WebView',
        state:{name:newName,webViewHtml:(value=='bankProtocolName'?this.state.agreementValue.bankProtocolUrl:this.state.agreementValue.upProtocolUrl)},
        query: {code:code}
      })
    }
  }
  sure = () => {
    let { text, paymentChannelId } = this.state;
    let {addPhoneText}=this.props;
    let { bankAccountName, bankAccountShowNo, certNo, } = this.props.location.state;
    let regPhone = /^1[0123456789]\d{9}$/;
    if(!(regPhone.test(addPhoneText))){ 
      Toast.info( "手机号有误，请重新输入", Util.ToastTime ); 
      return ; 
    }
    Toast.loading('', 2);
    // if(!paymentChannelId) {
    //  Toast.info( "未自动获取到所属银行，请手动选择",Util.ToastTime );
    //  return ;
    // }
    // this.props.location.state.navigator.push({
    //   component: VerifyDynamicCode,
    //   params: {
    //     mobileNo: mobileNo,
    //     bankAccountName: bankAccountName,
    //     certType: this.props.certType,
    //     certNo: this.props.certNo,
    //     bankAccountShowNo: bankAccountShowNo,
    //     bankCode: this.props.bankCode,
    //     bankName: this.state.bankName,
    //     trustChannelId: this.state.paymentChannelId,
    //     route: this.props.route,
    //     refreshPage: this.props.refreshPage,
    //   }
    // })
    hashHistory.push({
        pathname:'/Verification',
        state:{
          length:this.props.location.state.length,
          content:this.props.location.state.content,
          mobileNo: this.props.addPhoneText,
          bankAccountName: this.props.location.state.bankAccountName,   
          certType: this.props.location.state.certType,
          certNo: this.props.location.state.certNo,
          bankAccountShowNo: this.props.location.state.bankAccountShowNo,
          cardName: this.props.location.state.cardName,
          bankCode: this.props.location.state.bankCode,
          trustChannelId: this.state.paymentChannelId,
          fundCode:this.props.location.state.fundCode,
          bankProtocolVersion: this.state.agreementValue.bankProtocolVersion,
          upProtocolVersion: this.state.agreementValue.upProtocolVersion
        }
    })
    this.setState({agreeIndex: 0})
  }

  async componentDidMount(){
    let params = {
      token: await getTempInfo("shortToken"),
      bankAccountNo: this.props.location.state.bankAccountShowNo
    }
    this.props.dispatch(getBankProtocollnfoList(params, (value)=>{
      this.setState({agreementValue: value})
    },(message)=>{Toast.info( message,Util.ToastTime );}))
  }
  render(){
    const img_arr = [require('../img/square.png'),require('../img/protocol_selected.png')];
    let flag=Util.regular1.test(this.props.addPhoneText)
    return (
        <div className="container" >
        <NavigatorMain>
          <div className="header black">
            <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
            <div>添加银行卡</div>
            <div></div>
          </div>
          </NavigatorMain>
          <div style={{WebkitFlex: 1, overflow: "auto"}}>
          <div className='content'>
           <div className='share'>
              <div className='shareTitle'>
                请绑定您本人的银行卡
              </div>
            </div>
            <div onClick={this.showActionSheet} className='contentHeader' style={{borderBottom:'1px solid #eaeaea'}}>
              <p style={{width:'1.5rem'}}>卡类型</p>
              <p style={{WebkitFlex:1}} >{ this.state.bankName||!this.state.bankName=='取消' ? this.state.bankName : '请选择所属银行'} </p>
            </div>
            <div className='contentHeader'>
              <p style={{width:'1.5rem'}}>手机号</p>
              <input autocomplete="off" style={{WebkitFlex:1}} onChange={(e)=>this.onChangeText(e)} type="text" value={this.props.addPhoneText} placeholder={'请输入银行预留手机号'} />
            </div>
            {flag&&this.state.paymentChannelId && this.state.agreementValue?
            <div onClick={()=>this.next()} className='btn'>
              下一步
            </div>:
            <div className='btn btn-gray'>
              下一步
            </div>
            }
            <div className='addCard-tipBox'>
              <p>温馨提示 :</p>
              <p>如果您的银行卡是由交通银行、浦发银行、平安银行或邮储银行发行的。您需要先通过电脑访问银联官网开通该卡的银联在线支付，网址：https://www.95516.com/static/union/pages/card/openFirst.html?entry=openPay。开通成功后，再通过APP绑定该类银行卡即可。为此造成的不便，敬请谅解。</p>
            </div>
          </div>
          </div>
          {
            this.state.verificationCodeBool ?
            <div style={{position: "fixed", top: 0, bottom: 0, left: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.6)", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <div style={{width: 295, paddingBottom: 20, borderRadius: 4, backgroundColor: "#fff"}}>
                <div style={{paddingTop: 20, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <p style={{fontSize: 18, color: "#333", fontWeight: 500}}>温馨提示</p>
                </div>
                <div style={{paddingTop: 12, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center" , paddingLeft: 20, paddingRight: 20, fontSize:'0.28rem'}}>
                    <img src={img_arr[this.state.agreeIndex]} className='imgBtn' style={{marginTop:'-0.35rem'}} onClick={()=>this.isAgreeClick()}/>
                    <p style={{lineHeight:'0.35rem'}}>我已阅读并同意
                      <span style={{color:"#fa063a"}} onClick={()=>this.ProtocolPaper('上海华夏财富投资管理有限公司快易付业务协议','')}>《上海华夏财富投资管理有限公司快易付业务协议》</span>、
                      <span style={{color:"#fa063a"}} onClick={()=>this.ProtocolPaper(this.state.agreementValue.bankProtocolName,'bankProtocolName')}>{this.state.agreementValue.bankProtocolName}</span>、
                      <span style={{color:"#fa063a"}} onClick={()=>this.ProtocolPaper(this.state.agreementValue.upProtocolName,'upProtocolName')}>{this.state.agreementValue.upProtocolName}</span>
                    </p>
                </div>
                <div style={{paddingTop: 15, display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlexDirection: "row"}}>
                  <div onClick={()=>{this.setState({verificationCodeBool: false, agreeIndex: 0})}} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", borderStyle: "solid", borderWidth: 1, borderColor: "#F92C3D", backgroundColor: "transparent", width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#F92C3D"}}>取消</p>
                  </div>
                  {
                    this.state.agreeIndex==1?
                  <div onClick={this.sure} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#F92C3D", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#fff"}}>同意并继续</p>
                  </div>
                  :
                  <div onClick={()=>{Toast.info( "请先阅读并确认协议",Util.ToastTime );}} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", backgroundColor: "#ccc", marginLeft: 10, width: 122, height: 32, borderRadius: 4}}>
                    <p style={{fontSize: 14, color: "#fff"}}>同意并继续</p>
                  </div>
                  }
                  
                </div>
              </div>
            </div>
            :
            null
          }
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    addPhoneText:state.addPhoneText
  }
}
export default connect(mapStateToProps)(AddPhone);



// WEBPACK FOOTER //
// ./src/components/AddPhone.js